import type { ReactNode } from "react";
import { handleLinkClick } from "../lib/router";
import { AlphaMark } from "../components/AppHeader";

/**
 * The shared layout for candlealpha's three static pages (how-to-play, data,
 * privacy) and the not-found view (GRA-153): a real heading, a link back to
 * the game, and plain text in the app's own type and colors. Deliberately
 * plain: these are reference pages, not part of the keyboard-first game
 * loop, so there is no chrome to keep consistent with the header.
 */
export function PageShell({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col gap-6 px-6 py-10 font-mono text-fg">
      <a
        href="/"
        onClick={handleLinkClick("/")}
        className="flex w-fit items-center gap-[0.2em] text-sm text-muted transition-colors hover:text-accent"
        aria-label="back to candle alpha"
      >
        ← back to candle
        <AlphaMark className="ml-px h-[1.05em] w-[1.05em] shrink-0" />
      </a>
      <h1 className="text-xl text-fg">{title}</h1>
      <div className="flex flex-col gap-5 text-sm leading-relaxed text-muted [&_a]:text-accent [&_a:hover]:underline [&_h2]:mt-2 [&_h2]:text-base [&_h2]:text-fg [&_strong]:font-normal [&_strong]:text-fg [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mt-1">
        {children}
      </div>
    </main>
  );
}
